import SearchQuery from './SearchQuery.js';
import {RANDOM} from 'constants/sort-by.js';

const RECENT_QUERIES_SIZE = 25;

class SearchCache {
    constructor() {
        this.recentQueries = [];
        this.guildId = 0;
    }

    setStore(store) {
        if (this.store === undefined && store) {
            this.store = store;
            this.store.subscribe(() => this.onChange());
        }
    }

    onChange() {
        let selectedGuild = this.store.getState().guilds.selectedGuild;
        let guildId = selectedGuild ? selectedGuild.guildId : 0;
        if (guildId !== this.guildId) {
            console.log('guild changed to guildId = ' + guildId);
            this.guildId = guildId;
            this.clear();
        }
    }

    clear() {
        this.recentQueries = [];
    }

    createSearchQuery(searcher, allSounds=false) {
        let searchQuery = new SearchQuery(this.store);

        searchQuery.selectedTags = searcher.selectedTags;
        searchQuery.selectedOrTags = searcher.selectedOrTags;
        searchQuery.selectedStyles = searcher.selectedStyles;
        searchQuery.selectedVideos = searcher.selectedVideos;
        searchQuery.selectedDiscogs = searcher.selectedDiscogs;
        searchQuery.selectedCountries = searcher.selectedCountries 
        searchQuery.filterFavorites = searcher.filterFavorites;
        searchQuery.fromDate = searcher.fromDate;
        searchQuery.chord = searcher.chord === undefined ? undefined : [... searcher.chord];
        searchQuery.year = searcher.year;
        if (!allSounds) {
            searchQuery.sampleToRanking = searcher.sampleToRanking;
        }
        return searchQuery;
    }

    getSearchQueryIfExists(searcher, allSounds=false) {
        let query = this.createSearchQuery(searcher);
        let filtered = this.recentQueries.filter(q => query.equals(q) && !query.canceled);
        filtered = filtered.length == 0 ? undefined : filtered[0];
        if (filtered !== undefined && !allSounds) {
            filtered.sampleToRanking = searcher.sampleToRanking;
            filtered.canceled = false;
        }

        if (filtered !== undefined) {
            // sorting a found query
            filtered.sort();
        }

        return filtered;
    }

    addNewQuery(query) {
        this.recentQueries.push(query);

        if (this.recentQueries.length > RECENT_QUERIES_SIZE) {
            this.recentQueries.splice(0, 1);
        }
    }
}

export default SearchCache;
